import { lazyImages } from '@/components/lazyImages'
const KEY = "waiheke-shortlist";
const ACTIVE_CLASS = "shortlist-heart--active";
const RENDER_ENDPOINT = "/renderlist";

// TODO - Improve this function with fallbacks and errors
export function renderShortlist(element) {
    if (!element) {
        throw "HTMLElement required to render shortlist items";
    }

    const list = getShortlist();
    const options = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "x-requested-with": "XMLHttpRequest",
        },
        body: JSON.stringify(list),
    };

    fetch(window.location.href + RENDER_ENDPOINT, options)
        .then((response) => response.json())
        .then((data) => {
            if (data.length > 0) {
                element.innerHTML = data.join("");

                trackShortlist();
                trackShortlistDOM(element);
                // We need to call this after render since these elements
                // aren't in the DOM until AFTER this function runs
            } else {
                element.innerHTML =
                    "<p>There are no items in your shortlist</p>";
            }
        });
}

export function trackShortlistDOM(element) {
    const tiles = element.querySelectorAll(".tile");
    tiles.forEach((tile) => {
        lazyImages()
        tile.addEventListener("click", () => {
            tile.addEventListener("animationend", () => {
                tile.remove();
            });
            tile.classList.add("tile--delete");
        });
    });
}

export function getShortlist() {

    const result = localStorage.getItem(KEY);

    if (result === null) {
        return createShortlist();
    }

    const parsed = JSON.parse(result);

    if(!Array.isArray(parsed)) {
        emptyShortlist()
    }

    if(!parsed.every(v => typeof v === 'number')) {
        emptyShortlist()
    }

    return parsed;
}

export function createShortlist() {
    const result = localStorage.getItem(KEY);

    if (result === null) {
        localStorage.setItem(KEY, JSON.stringify([]));
        return [];
    } else {
        throw `Shortlist already exists. Try using emptyShortlist() before creating a shortlist.`;
    }
}

export function emptyShortlist() {
    localStorage.setItem(KEY, JSON.stringify([]));
}

export function existsInShortlist(data) {
    const list = getShortlist();
    return list.find((item) => item === data.id) ? true : false;
}

export function addToShortlist(data) {
    if (!data.id) {
        throw `data must have an id.`;
    }

    if (!typeof data.id === "number") {
        throw `data.id must be a valid number`;
    }

    const list = getShortlist();

    const found = list.find((item) => item === data.id);

    if (found) {
        throw `That id already exists in the shortlist.`;
    }

    list.push(data.id);
    localStorage.setItem(KEY, JSON.stringify(list));
    return list;
}

export function removeFromShortlist(data) {
    if (!data.id) {
        throw `data must have an id.`;
    }

    if (!typeof data.id === "number") {
        throw `data.id must be a valid number`;
    }

    const list = getShortlist();

    const index = list.indexOf(data.id);

    if (index === -1) {
        throw `That id doesn't exist in the shortlist.`;
    }

    list.splice(index, 1);

    localStorage.setItem(KEY, JSON.stringify(list));
    return list;
}

export function trackShortlist() {
    const hearts = document.querySelectorAll(".shortlist-heart");

    hearts.forEach((heart) => {
        heartExistsDecorator(heart);
        heart.addEventListener("click", heartEventListener);
    });

    updateIndicator()
}

export function updateIndicator() {
    const indicator = document.querySelector('.shortlist-indicator')

    if(!indicator) {
        return
    }

    const inner = indicator.querySelector('span')

    const list = getShortlist()

    inner.innerText = list.length

    if(list.length) {
        indicator.classList.add('shortlist-indicator--active')
    } else {
        indicator.classList.remove('shortlist-indicator--active')
    }
}

function heartExistsDecorator(heart) {
    const data = { ...heart.dataset };
    data.id = parseInt(data.id);
    if (existsInShortlist(data)) {
        heart.classList.add(ACTIVE_CLASS);
    } else if (heart.classList.contains(ACTIVE_CLASS)) {
        heart.classList.remove(ACTIVE_CLASS);
    }
}

function heartEventListener(e) {
    e.preventDefault();
    const data = { ...e.target.dataset };
    data.id = parseInt(data.id);

    if (existsInShortlist(data)) {
        removeFromShortlist(data);
    } else {
        addToShortlist(data);
    }

    updateIndicator()

    heartExistsDecorator(e.target);
    const hearts = document.querySelectorAll(".shortlist-heart");

    hearts.forEach((heart) => {
        heartExistsDecorator(heart);
    });

}
